module.exports = __webpack_public_path__ + "static/media/inkk-logo_ru.cb10ee89.png";